import { render, staticRenderFns } from "./StockCalcResultTable.vue?vue&type=template&id=35bc4a45"
import script from "./StockCalcResultTable.vue?vue&type=script&lang=js"
export * from "./StockCalcResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports